var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "row mx-0",
      class: _vm.zigzag.fragmentClasses,
      attrs: { id: "anchor-zig-zag" },
    },
    _vm._l(_vm.zigzag.zigZagItems, function (zigZag, index) {
      return _c(
        "div",
        { key: "zigzag-" + index, staticClass: "col-12 p-md-0" },
        [
          _c(
            "div",
            {
              class: `card ob1-push ob1-push-zigzag ob1-push-shadow-right ${
                index === _vm.zigzag.zigZagItems.length - 1
                  ? _vm.additionalClasses
                  : ""
              } ${_vm.definePictureLayout(index)}`,
            },
            [
              _c("div", { staticClass: "card-item" }, [
                zigZag.image
                  ? _c(
                      "div",
                      {
                        staticClass: "card-header",
                        class: [
                          index === _vm.zigzag.zigZagItems.length - 1
                            ? _vm.additionalClasses
                            : "",
                          _vm.withImageResize ? "zigzag-image-container" : "",
                        ],
                      },
                      [
                        _c("ob1-picture", {
                          attrs: {
                            "css-classes": "card-img-top",
                            visual: zigZag.image,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                zigZag.video
                  ? _c(
                      "div",
                      { staticClass: "card-header" },
                      [
                        _c("video-container", {
                          attrs: {
                            "css-classes": "card-img-top",
                            src: zigZag.video,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-item" },
                _vm._l(zigZag.body, function (item, itemIndex) {
                  return _c(
                    "div",
                    { key: "body-" + itemIndex, staticClass: "card-body" },
                    [
                      _c(
                        "h3",
                        {
                          staticClass: "card-title",
                          attrs: { "data-clamp": "2" },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(item.title) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "card-text",
                        domProps: { innerHTML: _vm._s(item.textHtml) },
                      }),
                      _vm._v(" "),
                      item.btnLabel !== ""
                        ? _c("p", { staticClass: "pb-2 card-btn" }, [
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-secondary",
                                attrs: {
                                  href: item.btnLink,
                                  "data-oevent-category": item.btnTms.tagZone,
                                  "data-oevent-action": item.btnTms.tagName,
                                  "data-oevent-label": item.btnTms.tagTarget,
                                },
                              },
                              [_vm._v(_vm._s(item.btnLabel))]
                            ),
                          ])
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }